import { Achievement } from '../Api'

export const HelmetHuntLogo =
  'https://premierlacrosseleague.com/wp-content/uploads/2024/06/HelmetHuntWeek_3Dhorizontal.webp'
export const DEFAULT_BADGE_USER = '1111'
export const HelmetHuntCommunityAchievement: Achievement = {
  startTime: 0,
  successMetric: 0,
  event: '',
  endTime: 0,
  expireTime: 0,
  text: '',
  id: 99999999999,
  description: '',
  expValue: 0,
  metricType: 'participants',
  type: 'community',
  userProgress: 0,
  link: 'https://premierlacrosseleague.com/helmet-hunt-week',
  status: '',
  achStructure: 'community-multi',
  successMetricArr: [
    {
      metricId: 1,
      expValue: 0,
      successMetric: 5000,
    },
    {
      metricId: 2,
      expValue: 0,
      successMetric: 15000,
    },
    {
      metricId: 1,
      expValue: 0,
      successMetric: 25000,
    },
  ],
  week: 23,
  year: 2024,
  season: 2,
  levelRewards: [
    {
      title: '5K Participants',
      img: 'https://premierlacrosseleague.com/wp-content/uploads/2024/07/black-hh.webp',
      desc: 'Black Helmet & 1K XP',
    },
    {
      title: '15K Participants',
      img: 'https://premierlacrosseleague.com/wp-content/uploads/2024/07/platinum-hh.webp',
      desc: `Silver Helmet, 
10 Champ tix & 2.5K XP`,
    },
    {
      title: '25K Participants',
      img: 'https://premierlacrosseleague.com/wp-content/uploads/2024/07/gold-hh.webp',
      desc: `Gold Helmet, 
100 Champ tix & 7.5K XP`,
    },
  ],
}
